<template>
  <div class="home">
    <UserLogin />
  </div>
</template>

<script>
import UserLogin from "@/components/UserLogin.vue";

export default {
  name: "home",
  components: {
    UserLogin,
  },
};
</script>
